import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaExternalLinkAlt,
  FaMicrophone,
  FaLanguage,
  FaChartLine,
  FaRobot,
} from "react-icons/fa";

function VoyceeShowcase() {
  return (
    <Container fluid className="voycee-section">
      <Container>
        <div className="voycee-badge-wrapper">
          <span className="voycee-badge">FEATURED PRODUCT</span>
        </div>
        <Row className="voycee-content align-items-center">
          <Col lg={7} md={12} className="voycee-info">
            <h2 className="voycee-title">Voycee</h2>
            <p className="voycee-tagline">AI Voice Assistance Platform</p>
            <p className="voycee-description">
              Built end-to-end — a production Voice AI system that automates
              inbound calls for <strong>restaurants</strong> and{" "}
              <strong>hospitals</strong>. Handles reservations, appointment
              booking, order status, department routing, and FAQs in
              <strong> English and Spanish</strong> with a real-time analytics
              dashboard.
            </p>
            <div className="voycee-stats-grid">
              <div className="voycee-stat">
                <FaMicrophone className="voycee-stat-icon" />
                <span className="voycee-stat-number">80%</span>
                <span className="voycee-stat-label">Fewer Missed Calls</span>
              </div>
              <div className="voycee-stat">
                <FaLanguage className="voycee-stat-icon" />
                <span className="voycee-stat-number">2</span>
                <span className="voycee-stat-label">Languages</span>
              </div>
              <div className="voycee-stat">
                <FaRobot className="voycee-stat-icon" />
                <span className="voycee-stat-number">24/7</span>
                <span className="voycee-stat-label">Automated</span>
              </div>
              <div className="voycee-stat">
                <FaChartLine className="voycee-stat-icon" />
                <span className="voycee-stat-number">Live</span>
                <span className="voycee-stat-label">Analytics</span>
              </div>
            </div>
            <div className="voycee-tech-tags">
              <span className="voycee-tag">Python</span>
              <span className="voycee-tag">FastAPI</span>
              <span className="voycee-tag">React 18</span>
              <span className="voycee-tag">Voice AI</span>
              <span className="voycee-tag">Conversational AI</span>
            </div>
            <a
              href="https://voycee.com"
              target="_blank"
              rel="noreferrer"
              className="voycee-cta"
            >
              Visit Voycee.com{" "}
              <FaExternalLinkAlt
                style={{ marginLeft: "8px", fontSize: "0.85em" }}
              />
            </a>
          </Col>
          <Col lg={5} md={12} className="voycee-visual-col">
            <div className="voycee-glow-card">
              <div className="voycee-glow-card-inner">
                <div className="voycee-icon-large">
                  <FaMicrophone />
                </div>
                <div className="voycee-features">
                  <div className="voycee-feature-item">
                    Reservations & Booking
                  </div>
                  <div className="voycee-feature-item">
                    Order Status Checks
                  </div>
                  <div className="voycee-feature-item">Department Routing</div>
                  <div className="voycee-feature-item">
                    After-Hours Handling
                  </div>
                  <div className="voycee-feature-item">FAQ Automation</div>
                  <div className="voycee-feature-item">
                    Real-time Dashboard
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default VoyceeShowcase;
